"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isFunction_1 = __importDefault(require("lodash/fp/isFunction"));

var isObject_1 = __importDefault(require("lodash/fp/isObject"));

var actions_1 = require("./actions");

var warnings_1 = require("./warnings");

function defaultTransformer(state) {
  return state;
}

function isValidAction(action) {
  var isFunc = isFunction_1.default(action);
  var isObj = isObject_1.default(action);
  var hasType = isObj && action.hasOwnProperty('type');

  if (!isFunc && isObj && hasType) {
    return true;
  }

  if (process.env.NODE_ENV !== 'production') {
    if (isFunc) {
      console.warn(warnings_1.receivedFunctionalAction());
    } else if (!isObj) {
      console.warn(warnings_1.receivedNonObjectAction(action));
    } else if (!hasType) {
      console.warn(warnings_1.missingActionType());
    }
  }

  return false;
}

function createMiddleware(engine) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = Object.assign({
    disableDispatchSaveAction: false
  }, options);
  return function (store) {
    var dispatch = store.dispatch,
        getState = store.getState;
    return function (next) {
      return function (action) {
        var result = next(action);

        if (!isValidAction(action)) {
          return result;
        }

        var isOwnAction = action.type === actions_1.SAVE || action.type === actions_1.LOAD;
        var isBlacklisted = isOwnAction || options.filterAction && !options.filterAction(action);

        if (!isBlacklisted) {
          var transform = options.transform || defaultTransformer;
          var saveState = transform(getState());
          var saveAction = actions_1.save(saveState);

          if (process.env.NODE_ENV !== 'production') {
            if (!saveAction.meta) {
              saveAction.meta = {};
            }

            saveAction.meta.origin = action;
          }

          var dispatchSave = function dispatchSave() {
            return dispatch(saveAction);
          };

          engine.save(saveState).then(function () {
            if (opts.disableDispatchSaveAction === false) {
              return dispatchSave();
            }
          }, function (e) {
            if (options.onError) {
              options.onError(e, store);
            } else {
              if (process.env.NODE_ENV !== 'production') {
                console.warn(warnings_1.defaultErrorHandler());
              }

              console.error(e);
            }
          });
        }

        return result;
      };
    };
  };
}

exports.createMiddleware = createMiddleware;